import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useInvalidateBills } from '@features/bills/hooks/useInvalidateBills'

import { useDeleteBill } from './useDeleteBill'

interface UseDeleteBillActionProps {
  onSuccess?: (data: void) => void
}

export const useDeleteBillAction = ({ onSuccess }: UseDeleteBillActionProps) => {
  const { t } = useTranslation()
  const { invalidateBills } = useInvalidateBills()

  const { delete: deleteBill, isLoading: isDeleting } = useDeleteBill({
    onSuccess: async () => {
      notify({
        id: 'bill-deleted',
        message: t('bill.notification.delete_success'),
        variant: 'success',
      })

      await invalidateBills()

      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error) => {
      notify({
        id: 'bill-deleted',
        message: error?.message || t('bill.notification.delete_error'),
        variant: 'error',
      })
    },
  })

  return { deleteBill, isDeleting }
}
